export const CARD_TYPES = {
  COLOR: 'color',
  IMAGE: 'image',
  VIDEO: 'video',
};

export const TEXT_POSITIONS = {
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_LEFT: 'bottom-left',
  CENTER: 'center',
  TOP_CENTER: 'top-center',
  TOP_LEFT: 'top-left',
};

export const ANIMATION_TYPES = {
  FADE_IN: 'fadeIn',
  NONE: 'none',
  SLIDE_UP: 'slideUp',
};
